module.exports = __webpack_public_path__ + "static/media/p1.72294ce2.png";